import {BillingProvider} from '../types';

// Mirrors billing-api src/appsync-api/src/schema/features/billing-providers.graphql.
// AppSync rejects the WHOLE mutation when the input carries a key the Input type does not
// declare, so the payload names the fields it sends rather than stripping keys off the
// form state (FNP-1905: Add carried `id: ''`, the detail-page Edit carried
// `createdByUser`, and both were always rejected).
//
// `createdByUsername` and `created` (create) and `updated` (update) are declared too, but
// the resolvers set them server-side, so the client never sends them.
export type CreateBillingProviderInput = {
    key: string,
    name?: string | null,
    description?: string | null,
    status: BillingProvider['status'],
};

export type UpdateBillingProviderInput = CreateBillingProviderInput & {
    id: string,
};

// A new provider always starts Enabled: the add form has no status field.
export const buildCreateBillingProviderInput = (values: BillingProvider): CreateBillingProviderInput => ({
    key: values.key,
    name: values.name,
    description: values.description,
    status: 'Enabled',
});

export const buildUpdateBillingProviderInput = (id: string, values: BillingProvider): UpdateBillingProviderInput => ({
    id,
    key: values.key,
    name: values.name,
    description: values.description,
    status: values.status,
});
